import { render, staticRenderFns } from "./PriceAlert.vue?vue&type=template&id=a4c4b5a4&scoped=true&"
import script from "./PriceAlert.vue?vue&type=script&lang=js&"
export * from "./PriceAlert.vue?vue&type=script&lang=js&"
import style0 from "./PriceAlert.vue?vue&type=style&index=0&id=a4c4b5a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c4b5a4",
  null
  
)

export default component.exports